import {Navigate, useLocation} from "react-router-dom";
import {getArtistFromPath} from "src/utils/artist.utils";
import {ARTIST_LAUNCH_DATES} from "src/utils/launchDate.constants";
import {path} from "src/router/path";

interface LaunchDateGuardProps {
  children: React.ReactNode;
}

const LaunchDateGuard = ({children}: LaunchDateGuardProps) => {
  const {pathname} = useLocation();
  const artist = getArtistFromPath(pathname);
  const isLaunched = new Date() >= ARTIST_LAUNCH_DATES[artist];

  if (!isLaunched) {
    return <Navigate to={path.error(artist)} replace />;
  }

  return <>{children}</>;
};

export default LaunchDateGuard;
